import React, { Component } from 'react';
import {connect} from 'react-redux';
import PerkAction from '../../actions/PerkAction';
import Preloader from '../Preloader';

class ViewPerk extends Component {

  componentDidMount() {
    if (this.props.params.id) {
      this.props.getPerk(this.props.params.id);
    }
  }

  render() {
    if (this.props.isBusy) {
      return <Preloader />;
    } else {
      return <div>
        <div className="row" style={{margin: '0px 15px'}}>
          <div className="col-md-12">
            <div className="panel panel-default">
              <div className="panel-heading">
                <h3 className="panel-title">View perk</h3>
              </div>
              <div className="panel-body">
                <div>
                  <div className="form-group">
                    <label htmlFor="title" className="bold">Title</label>
                    <div>{this.props.perkForm.title}</div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="description" className="bold">Description</label>
                    <div>{this.props.perkForm.description}</div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="referral_bonus" className="bold">Referral bonus</label>
                    <div>{this.props.perkForm.referral_bonus ? 'yes' : 'no'}</div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="referral_bonus" className="bold">Enabled</label>
                    <div>{this.props.perkForm.enabled ? 'yes' : 'no'}</div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="referral_bonus" className="bold">Requires QR code</label>
                    <div>{this.props.perkForm.requires_qr_code ? 'yes' : 'no'}</div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="fine_print" className="bold">Fine print</label>
                    <div>{this.props.perkForm.fine_print}</div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="required_referrals" className="bold">Required Referrals</label>
                    <div>{this.props.perkForm.required_referrals}</div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="expire_date" className="bold">Expire date</label>
                    <div>{this.props.perkForm.expire_date}</div>
                  </div>
                  <a href="/#/perks" className="btn btn-default ml10">Back to perks list</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  }
}

export default connect(
  state => ({
    perkForm: state.forms.perkForm,
    isBusy: state.requestStatus
  }),
  dispatch => ({
    getPerk: (id) => {
      dispatch(PerkAction.get(id));
    }
  })
)(ViewPerk);



/** WEBPACK FOOTER **
 ** ./src/components/Perks/view.js
 **/